export enum HISTORY_ACTIONS {
  POP = "POP",
  PUSH = "PUSH",
  REPLACE = "REPLACE",
}

export enum LOCAL_STORAGE_NAMES {
  LIVE_CHAT_NAME = "liveChatName",
  MEDIA_CONSTRAINTS = "mediaConstraints",
}

export enum SendDataEvent {
  PRODUCER_FINISHED_STREAM = "PRODUCER_FINISHED_STREAM",
  // Sent over the WebRTC data channel when a producer mutes/unmutes their mic
  // via track.enabled (no renegotiation). The audio producer stays open, so
  // producers-updated keeps reporting audio:true — consumers rely on this
  // explicit signal to light the mic_off indicator. Payload: { muted: boolean }.
  AUDIO_MUTED = "AUDIO_MUTED",
  // Sent over the WebRTC data channel when one side starts/stops recording
  // the call. The receiving side surfaces a "REC" indicator (and timer) so
  // both parties always see when recording is active — same UX promise as
  // group conferences.
  RECORDING_STARTED = "RECORDING_STARTED",
  RECORDING_STOPPED = "RECORDING_STOPPED",
}
